// Utility functions for asset transformation
import type { Task } from "~/types/bridge";
import { fixAndParseJson, sortBy } from "~/utils/utils";

export function transformAsset(asset: any): any {
  let updatedAsset = { ...asset };
  updatedAsset.id = asset.bid
  if (updatedAsset.vertical_fields && typeof updatedAsset.vertical_fields === "string") {
    let verticalFields = fixAndParseJson(updatedAsset.vertical_fields);
    updatedAsset.vertical_fields = verticalFields;
    verticalFields.forEach((field: any) => {
      const fieldName = field.name ? field.name : field.field_name;
      if (updatedAsset.hasOwnProperty(fieldName)) {
        verticalFields = verticalFields.filter(
          (field: any) => field.field_name !== fieldName,
        );
      } else {
        updatedAsset[fieldName] = updatedAsset[field.field];
        field.value = updatedAsset[field.field];
        delete updatedAsset[field.field];
      }
    });
  }
  removeFieldKeys(updatedAsset);
  return updatedAsset;
}

export function removeFieldKeys(asset: any): void {
  Object.keys(asset).forEach(key => {
    if (key.startsWith('field')) {
      delete asset[key];
    }
  });
}

export const mergeSurveyInfoIntoBridge = (bridges: any[], surveys: any[], tasks: Task[]) =>
  bridges.map(bridge => {
    let newBridge = { ...bridge };
    const bridgeSurveys = surveys.filter(survey => survey.bid == bridge.bid);
    // const lastUpdatedSurvey = getLatestUpdateditem(bridgeSurveys);
    const lastUpdatedSurvey = sortBy(bridgeSurveys,'id',  true)[0];
    if (lastUpdatedSurvey) {
      const surveyTasks = tasks.filter(task => task.survey_id === lastUpdatedSurvey.id);
      newBridge.children = surveyTasks;
      Object.keys(lastUpdatedSurvey).map(key => {
        if (bridge.hasOwnProperty(key)) {
          newBridge[`survey_${key}`] = lastUpdatedSurvey[key];
        } else {
          newBridge[key] = lastUpdatedSurvey[key];
        }
      });
    }
    return newBridge;
  });